import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "full-width"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["content"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!

  return (_ctx.storeLocation)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showTodayHours && _ctx.storeLocation.boldDisplayTime)
          ? (_openBlock(), _createBlock(_component_ion_label, {
              key: 0,
              innerHTML: _ctx.storeLocation.boldDisplayTime
            }, null, 8, ["innerHTML"]))
          : (_openBlock(), _createBlock(_component_ion_accordion_group, {
              key: 1,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      slot: "header",
                      class: "time-header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "pl-16" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              innerHTML: _ctx.storeLocation.boldDisplayTime
                            }, null, 8, _hoisted_2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.storeLocation.weeklyHours)
                      ? (_openBlock(), _createBlock(_component_ion_row, {
                          key: 0,
                          slot: "content",
                          class: "ion-padding-bottom color-dark"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeLocation.weeklyHours.slice(0, 7), (day, i) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                size: "12",
                                class: "py-0",
                                key: i
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("time", {
                                    itemprop: "openingHours",
                                    content: day.schema
                                  }, [
                                    _createVNode(_component_ion_row, { class: "ion-no-padding small" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_col, { class: "ion-text-end ion-margin-end py-4" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(day.day), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_ion_col, {
                                          size: "7",
                                          class: "py-4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(day.times), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 8, _hoisted_3)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]))
    : _createCommentVNode("", true)
}